import './styles.scss';

interface IProps {
    children: any
    size: number
    className?: string
    style?: any
    onClick?: any
    otherProps?: any
}

const Text = (props: IProps) => {
  return <span
    {...props}
    className={`text text--${props.size} ${props.className ? props.className : ''} ${props.onClick ? 'text--clickable' : ''}`}
    {...props.style}
    onClick={props.onClick}
  >
    {props.children}
  </span>;
};

export default Text;